export default __webpack_public_path__ + "static/media/flag-tr.4a0ce86b.svg";